import { createRoot } from 'react-dom/client'
import { ReactWidget } from './ReactWidget'

const widgetPayloads = window.novaThemeReactWidgets || {}

document.querySelectorAll('.nova-react-widget').forEach((element) => {
  if (element.__novaReactWidgetRoot) {
    return
  }

  const widgetId = element.dataset.novaReactWidgetId
  const payload =
    widgetPayloads[widgetId] || {
      id: widgetId || element.id || '',
      type: element.dataset.novaReactWidgetType || 'widget',
      html: element.innerHTML,
      props: {},
    }

  if (!payload.html) {
    return
  }

  element.__novaReactWidgetRoot = createRoot(element)
  element.__novaReactWidgetRoot.render(<ReactWidget payload={payload} />)
})
